import styled from 'styled-components/macro';
import { BaseButton } from '../../../shared/Button';
import { colourNeutral05, colourPurple06, colourPurple08 } from '../../../styling/colours';
import { fontSize01, fontWeightBold } from '../../../styling/fonts';
import { spacing05 } from '../../../styling/spacing';

export const AddItemButton = styled(BaseButton)`
  color: ${colourNeutral05};
  border: dashed 2px rgba(0, 0, 0, 0.1);
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing05} 0;
  width: 100%;
  text-align: center;
  height: auto;
  opacity: 1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: ${fontWeightBold};
  font-size: ${fontSize01};

  &:hover {
    opacity: 1;
    color: ${colourPurple06};
    border-color: ${colourPurple08};
  }

  &:focus {
    opacity: 1;
  }
`;
